// badge — wireframe skin module
// NO external imports — plain JavaScript only

const SIZE_FONT = {
  sm: 'var(--run-font-size-xs, 11px)',
  md: 'var(--run-font-size-xs, 12px)',
  lg: 'var(--run-font-size-sm, 14px)',
};

const SIZE_PADDING = {
  sm: '1px 6px',
  md: '2px 8px',
  lg: '3px 10px',
};

const SIZE_HEIGHT = {
  sm: '18px',
  md: '20px',
  lg: '24px',
};

export const styles = `
  :host {
    display: inline-flex;
    vertical-align: middle;
  }
`;

export function render(host) {
  const { size, pill, dot } = host;
  const fs      = SIZE_FONT[size]    || SIZE_FONT.md;
  const padding = SIZE_PADDING[size] || SIZE_PADDING.md;
  const height  = SIZE_HEIGHT[size]  || SIZE_HEIGHT.md;
  const radius  = pill ? '9999px' : 'var(--run-wf-radius, 3px)';

  if (dot) {
    const dotSize = size === 'sm' ? '6px' : size === 'lg' ? '10px' : '8px';
    host.shadowRoot.innerHTML = `
      <span part="badge" style="
        display: inline-block;
        width: ${dotSize};
        height: ${dotSize};
        border-radius: 9999px;
        background: var(--run-wf-text, #222);
        flex-shrink: 0;
      "></span>
    `;
    return;
  }

  host.shadowRoot.innerHTML = `
    <span part="badge" style="
      display: inline-flex;
      align-items: center;
      justify-content: center;
      height: ${height};
      min-width: ${height};
      padding: ${padding};
      font-size: ${fs};
      font-weight: 400;
      font-family: var(--run-wf-font-family, 'Courier New', monospace);
      line-height: 1;
      color: var(--run-wf-text, #222);
      background: transparent;
      border: 1px dashed var(--run-wf-border, #555);
      border-radius: ${radius};
      white-space: nowrap;
      box-sizing: border-box;
    "><slot></slot></span>
  `;
}
